import * as ko from "knockout";
import {nsRoute} from "../../util/route";
import {IRouteDefinitionParams} from "../../index";
import {lm} from "../../appContext";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import heading_labelHtml from './heading-label.html?raw';

export const template = heading_labelHtml;

interface IParams extends IRouteDefinitionParams {
    name: KnockoutObservable<string>
    num: KnockoutObservable<number>
}

export class viewModel extends ParsedRouteDataDecorator {
    private readonly _name: KnockoutObservable<string>

    constructor(params: IParams) {
        super(params);
        this._name = params.name
    }

    private name = ko.pureComputed(() => {
        return this._name() ?? ''
    })

    /** Shell folder pages (tabs in left nav): H1 follows the active tab, not the shell label. */
    private titleKey = ko.pureComputed(() => {
        if (this.__routeDef.showTabs === false && this.__tabManager) {
            const tabDef = this.__tabManager.currentTab()?.__routeDef ?? this.__tabRouteDef;
            const tabLabel = tabDef?.labelLong ?? tabDef?.label;
            if (tabLabel) {
                return typeof tabLabel === 'function' ? tabLabel() : tabLabel;
            }
        }
        const shellLabel = this.__routeDef.labelLong ?? this.__routeDef.label;
        return typeof shellLabel === 'function' ? shellLabel() : shellLabel;
    })

    private shouldShowType(): boolean {
        switch(this.__routeDef.id) {
            case 'apiuserdetails':
            case 'departmentdetails':
            case 'editmanualdepartment':
            case 'editmanualgroup':
            case 'editmanualuser':
            case 'editmessageflow':
            case 'editruleset':
            case 'editsynctemplate':
            case 'editsystemaccess':
            case 'groupdetails':
            case 'legalunitdetails':
            case 'manualapiuserdetails':
            case 'manualdepartmentdetails':
            case 'manualgroupdetails':
            case 'manualuserdetails':
            case 'messageflowdetails':
            case 'rulesetdetails':
            case 'sync':
            case 'synctemplatedetails':
            case 'systemaccessdetails':
            case 'userdetails':
                return true;
            default:
                return false
        }
    }
}
